if (!customElements.get('main-product-gallery')) {
  customElements.define(
    'main-product-gallery',
    class MainProductGallery extends HTMLElement {
      constructor() {
        super();

        this.mainCarouselSelector = '#main-carousel';
        this.thumbnailCarouselSelector = '#thumbnail-carousel';

       this.variants = this.getVariants();

        this.init();
        this.syncedVariantImage = this.dataset.syncedVariantImage;
        this.variantShouldTrigger = true;
      }

      connectedCallback() {
        subscribe(PUB_SUB_EVENTS.variantChange, this.handleVariantChange.bind(this));
      }

      init() {
        this.convertVariantsToArray();

        this.mainSlider = new Splide(this.querySelector(this.mainCarouselSelector), {
          type: 'loop',
          rewind: true,
          pagination: false,
          arrows: false,
          autoHeight: true,
          perPage: 1,
          heightRatio: 1,
          lazyLoad: 'nearby',
          preloadPages: 1,
        });

        if (window.matchMedia('(max-width: 600px)').matches) {
          if (this.querySelector(this.thumbnailCarouselSelector).dataset.showArrowsMobile === 'hide') {
            this.querySelector(this.thumbnailCarouselSelector).classList.add('hidden');
          } else {
            this.querySelector(this.thumbnailCarouselSelector).classList.remove('hidden');
          }
        } else {
          this.querySelector(this.thumbnailCarouselSelector).classList.remove('hidden');
        }

        this.thumbnailSlider = new Splide(this.querySelector(this.thumbnailCarouselSelector), {
          perPage: 5,
          gap: 10,
          pagination: false,
          dragMinThreshold: 10,
          isNavigation: true,
          arrows: this.querySelector(this.thumbnailCarouselSelector).dataset.showArrows === 'true',
          breakpoints: {
            600: {
              destroy: this.querySelector(this.thumbnailCarouselSelector).dataset.showArrowsMobile === 'hide',
            },
          },
          classes: {
            arrow: 'slider-button splide__arrow',
          },
        });

        this.mainSlider.sync(this.thumbnailSlider);
        this.mainSlider.mount();
        this.thumbnailSlider.mount();

        this.thumbnailSlider.on('moved', (newIndex) => {
          if (!this.variantShouldTrigger) {
            this.variantShouldTrigger = true;
            return;
          }
          this.variantShouldTrigger = true;

          const mediaId = this.thumbnailSlider.Components.Elements.slides[newIndex].dataset.mediaId;

          const currentVariantOptions = this.variants[mediaId] || null;

          if (currentVariantOptions) {
            this.syncedVariantImage = 'false'; // temporary flag to prevent triggering the event

            const variantSelects = this.closest('product-info').querySelectorAll('variant-selects fieldset');

            currentVariantOptions.forEach((option, index) => {
              const variantSelect = variantSelects[index];
              if (variantSelect) {
                const radio = variantSelect.querySelector(`input[value="${option}"]`);
                if (radio) {
                  radio.checked = true;
                  radio.dispatchEvent(new Event('change', { bubbles: true }));
                }
              }
            });
            this.syncedVariantImage = 'true';
          }
        });
      }

       getVariants() {
        const productInfo = this.closest('product-info');
        const productVariants = productInfo.querySelector('variant-selects [data-product-variants]')?.innerHTML;
        return !!productVariants ? JSON.parse(productVariants) : null;
      }

      convertVariantsToArray() {
        if (!this.variants) return;

        this.variants = Object.entries(this.variants)
          .filter(([key, value]) => value.featured_media?.id) // Check if featured_media.id exists
          .reduce((acc, [key, value]) => {
            acc[value.featured_media.id] = value.options;
            return acc;
          }, {});
      }

      handleVariantChange({ data: { variant } }) {
        if (!variant.featured_media || this.syncedVariantImage !== 'true') return;

        const variantFeaturedMediaId = variant.featured_media.id;

        let mediaPosition = this.querySelector(this.thumbnailCarouselSelector)?.querySelector(
          "[data-media-id='" + `${variantFeaturedMediaId}` + "']"
        )?.dataset.position;

        if (mediaPosition) {
          mediaPosition = parseInt(mediaPosition) - 1;
          if (mediaPosition != this.thumbnailSlider.index) {
            this.variantShouldTrigger = false;
            this.thumbnailSlider?.go(mediaPosition);
          }
        }
      }
    }
  );
}
